// Generated by purs version 0.13.0
"use strict";
var Chip_Model_Enemy = require("../Chip.Model.Enemy/index.js");
var Chip_Mutation_Direction = require("../Chip.Mutation.Direction/index.js");
var toggleTank = function (v) {
    if (v instanceof Chip_Model_Enemy.Tank) {
        return new Chip_Model_Enemy.Tank(Chip_Mutation_Direction.invert(v.value0));
    };
    return v;
};
module.exports = {
    toggleTank: toggleTank
};
